/**
 * 组件信息
 */
export const info = {
  name: 'xy-horizontal-layout', // 组件名
  type: 'component-container', // 组件类型
  label: '水平布局', // 组件label
  icon: 'icon-xy-horizontal-layout', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  scroll: { type: Boolean, default: false },
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: null,
      // 事件
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  },
  listIndex: {
    type: Object,
    default: null
  },
  listItemData: {
    type: [Object, Array, String, Number, Boolean],
    default: undefined
  },
  justifyContent: { type: String, default: 'left' }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-switch', // 表单组件
    label: '是否滚动', // 表单名称
    propKey: 'scroll' // 表单model字段名称
  },
  {
    type: 'xy-form-select',
    label: '对齐方式',
    propKey: 'justifyContent',
    options: [
      { label: '左对齐', value: 'flex-start' },
      { label: '右对齐', value: 'flex-end' },
      { label: '居中对齐', value: 'center' }
    ],
    isLanguage: true
  }
]
